<div class="outer-container">
  <div class="search-panel">
    <label class="search-box-label">What are you looking for?</label>
    <div class="unified-search-box">
      <div class="mcd-filter-dropdown-wrapper content-type-filter-wrapper">
        <button
          mat-button
          type="button"
          (click)="toggleContentTypeDropdown()"
          class="content-type-button"
        >
          {{ selectedOption.option }}
          <mat-icon
            class="content-type-chevron"
            [style.transform]="
              isContentTypeDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            "
            >expand_more</mat-icon
          >
        </button>

        <div class="mcd-dropdown-content" *ngIf="isContentTypeDropdownOpen">
          <div class="mcd-dropdown-options">
            <div class="dropdown-option-item">
              <mat-checkbox
                [checked]="selectedOption.id === filterOptions[0].id"
                (change)="selectOption(filterOptions[0])"
                (click)="$event.stopPropagation()"
              >
                {{ filterOptions[0].option }}
              </mat-checkbox>
            </div>
            <div class="filter-selected-divider"></div>
            <div
              class="dropdown-option-item"
              *ngFor="let option of filterOptions.slice(1)"
            >
              <mat-checkbox
                [checked]="selectedOption.id === option.id"
                (change)="selectOption(option)"
                (click)="$event.stopPropagation()"
              >
                {{ option.option }}
              </mat-checkbox>
            </div>
          </div>
          <div class="mcd-dropdown-actions">
            <button mat-button class="apply-btn" (click)="applyContentTypeFilter()">
              Apply
            </button>
          </div>
        </div>
      </div>
      <span class="search-box-divider"></span>
      <div class="input-wrapper">
        <svg
          (click)="apply()"
          class="search-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 50"
        >
          <path
            d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"
            fill="#eba900"
          ></path>
        </svg>
        <input
          placeholder="Search standards, equipment, approved solutions, exceptions and documents"
          matInput
          [(ngModel)]="searchQuery"
          (keyup.enter)="apply()"
          (input)="onSearchInputChange()"
          (keydown.enter)="apply()"
          (keyup)="showAlert($event)"
          class="search-input form-title"
          #searchInput
        />
      </div>
    </div>

    <div class="popular-searches">
      <span class="popular-label">Popular:</span>
      <button
        type="button"
        class="popular-chip"
        *ngFor="let term of popularSearches"
        (click)="searchQuery = term; apply()"
      >
        <img
          class="popular-chip-icon"
          src="/assets/images/popular search icon.svg"
          alt=""
        />
        {{ term }}
      </button>
    </div>

    <!-- Suggestions -->
    <div style="width: 100%; position: relative;">
      <div *ngIf="showSuggestions" style= "width:100%;position: absolute; z-index: 1000;">
        <app-search-suggestions [query]="searchQuery" [typeID]="selectedOption.id"></app-search-suggestions>
      </div>
    </div>
  </div>

  <!-- Error message for invalid input -->
  <mat-error *ngIf="invalidQuery" style="width: 100%; background: white">
    <p style="width: 100%; text-align: center">Please enter a non-empty value.</p>
  </mat-error>
</div>
